// import React, {  useEffect,useState } from 'react'
// import { BrowserRouter, Route, Routes } from 'react-router-dom'
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './Assets/Css/home.css'

// import { FaWhatsapp } from "react-icons/fa";


// import ScrollToTop from './Webpages/ScrollToTop'
// import { FaArrowUp } from "react-icons/fa6";

// import WebHeader from './Components/WebHeader'
// import WebFooter from './Components/WebFooter'
// import HomePage from './Webpages/HomePage'
// import About from './Webpages/About';
// import ProductPage from './Webpages/ProductPage';
// import Contact from './Webpages/Contact';
// import Gallery from './Webpages/Gallery';








// // Pages
// const App = () => {

//   const [showScroll, setShowScroll] = useState(false);

//   useEffect(() => {
//     const checkScroll = () => {
//       if (window.scrollY > window.innerHeight / 2) {
//         setShowScroll(true);
//       } else {
//         setShowScroll(false);
//       }
//     };

//     window.addEventListener("scroll", checkScroll);
//     return () => window.removeEventListener("scroll", checkScroll);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

 

//   return (
//     <BrowserRouter>
      
//         <WebHeader/>
//         <div>
//           <ScrollToTop/>
//         <Routes>

//           <Route path="*" name="HomePage" element={<HomePage />} />
//           <Route path="/" name="HomePage" element={<HomePage/>} />
//            <Route path="/aboutus" name="About" element={<About/>} />
//          <Route path="/products" name="ProductPage" element={<ProductPage/>} />
//          <Route path="/gallery" name="Gallery" element={<Gallery/>} />
         
//          <Route path="/contact" name="Contact" element={<Contact/>} />
         
          
//         </Routes>
//         <a
//           href="https://api.whatsapp.com/send/?phone=9822980560 &text=Hello%2C&type=phone_number&app_absent=0"
//           className="whatsapp-icon"
//           target="_blank"
//           rel="noopener noreferrer"
//           title="Chat with us!"
//         >
//           <FaWhatsapp />
//         </a>
//         {/* Scroll-To-Top Button */}
        
//         {showScroll && (
//   <button className="scroll-to-top show" onClick={scrollToTop}>
// <FaArrowUp />

//   </button>

// )}




//         </div>
//      <WebFooter/>
      
//     </BrowserRouter>
//   )
// }

// export default App











import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Assets/Css/home.css';

import { FaWhatsapp } from "react-icons/fa";
import { FaArrowUp } from "react-icons/fa6";

import WebHeader from './Components/WebHeader';
import WebFooter from './Components/WebFooter';
import ScrollToTop from './Webpages/ScrollToTop';
import HomePage from './Webpages/HomePage';

const App = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      setShowScroll(window.scrollY > window.innerHeight / 2);
    };
    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const scrollToTop = () => {
    const offset = 100; // Total height of fixed header (top bar + navbar)
    window.scrollTo({ top: offset, behavior: "smooth" });
  };

  return (
    <BrowserRouter>
      <WebHeader />
      <div>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>

       

        {showScroll && (
          <button className="scroll-to-top show" onClick={scrollToTop}>
            <FaArrowUp />
          </button>
        )}
      </div>
      <WebFooter />
    </BrowserRouter>
  );
};

export default App;
